import { ENV_VARS } from '@/env';
import { Col, Modal, Row } from 'antd';
import i18n from 'i18next';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import Button from '../Buttons/Button';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';

const AlertModal = ({
  open = false,
  title = 'Alert',
  okText = i18n.t('translation:default.options.ok'),
  description = i18n.t('translation:default.fields.description'),
  onClose = () => {},
  onOk = () => {},
  okButtonVariant = 'success',
  okLoading = false,
  closeButtonId = 'alert-close',
  okButtonId = 'alert-ok',
}) => {
  return (
    <Modal className="common-confirmation-modal" closable={false} centered footer={false} open={open}>
      <Row
        className={`header-section ${ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-bg-color' : ''}`}
        justify="space-between"
        align="middle"
      >
        <Col>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
          <label className="title">{title}</label>
        </Col>
        <Col className="lh-0">
          <IconButton onClick={onClose} disabled={okLoading} id={closeButtonId}>
            <SvgConverter Icon={CloseIcon} color="white" />
          </IconButton>
        </Col>
      </Row>
      <div className="content-section">
        <div className="description">{description}</div>
        <Row className="footer-section" justify="end">
          <Col>
            <Button
              variant={okButtonVariant}
              onClick={onOk}
              loading={okLoading}
              id={okButtonId}
              className={ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-button' : ''}
            >
              {okText}
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default AlertModal;
